import { useState } from 'react'
import { MdFilterList } from 'react-icons/md'
import styled from 'styled-components'
import FilterList from './filter-list'

const FilterBarStyled = styled.div`
  margin-inline-end: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
  .filters {
    padding: 0;
    display: flex;
  }
`

function FilterBar({ filters }) {
  const [open, setOpen] = useState('')
  const handleOpen = (id) => {
    if (open === id) {
      setOpen('')
      return
    }
    setOpen(id)
  }
  return (
    <FilterBarStyled>
      <MdFilterList size={20} />
      <menu className="filters">
        {filters.map((filter) => (
          <FilterList key={filter.id} {...filter} isOpen={open === filter.id} handleOpen={handleOpen} />
        ))}
      </menu>
    </FilterBarStyled>
  )
}

export default FilterBar
